<template>
<div>
  <baseaktarim :logo="null" title="Bizi Travel Otel Aktarımı" v-model="items" v-on:submitfile="SubmitFile" :status="status"></baseaktarim>
</div>
</template>

<script>
import baseaktarim from "../aktarim/coperbaseaktarim";
import tool from "../../coper/tools";
import helpers from "@/components/app/customcomp/helpers.js"

export default {
  data() {
    return {
      items: [],
      status: tool.NewSatatus(),
    };
  },
   
  components: {
    baseaktarim,
  },
  methods: {
    SubmitFile(files) {
      let formData = new FormData();
      for (var i = 0; i < files.length; i++) {
        let file = files[i];
        formData.append('files[' + i + ']', file);
      }

      this.status.loading = true;
      tool.api_file_post(this, "CoperStream/BiziTravelStream", formData).then(
        response => {
          this.items = response.body;
          this.status.loading = false;
        },
        response => {
          this.status = tool.responseToStatus(response);
        }
      );

    }
  }

};
</script>
